import { render, staticRenderFns } from "./Semantics.vue?vue&type=template&id=20e9bd48&scoped=true&"
import script from "./Semantics.vue?vue&type=script&lang=js&"
export * from "./Semantics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9bd48",
  null
  
)

export default component.exports